















import Vue from 'vue'
import Page from '@/components/layouts/Page.vue'

export default Vue.extend({
  name: 'SysInfo',

  components: {
    Page,
  },
  props: {
  },
  data: () => ({
    processEnv: {
      environment: process.env.environment,
      apiUrl: process.env.apiUrl,
      firestoreEmulatedUrl: process.env.firestoreEmulatedUrl,
      apiKey: process.env.apiKey,
      authDomain: process.env.authDomain,
      databaseURL: process.env.databaseURL,
      projectId: process.env.projectId,
      storageBucket: process.env.storageBucket,
      messagingSenderId: process.env.messagingSenderId,
      appId: process.env.appId,
    },
  }),
  computed: {
  },
  methods: {

  },

})

